import { graphql, useStaticQuery } from 'gatsby';
import React from 'react'
//@ts-ignore
import styles from './socialbar.module.css';

const useSocialBar = () => {
    const data = useStaticQuery(graphql`
        query {
            allContentfulLink(filter: {buttonText: {in: ["twitter", "facebook", "instagram", "LinkedIn", "youtube"]}}) {
                nodes {
                        buttonText
                  url
                }
            }
        }
    `);
    const socialsData = data?.allContentfulLink?.nodes;
    return socialsData;
}
export const SocialBar: React.FunctionComponent = () => {
    const socialsData = useSocialBar();
    return (
        <section className={styles.socialSection}>
            <div>Follow us</div>
            <div className={styles.socialsLogo}>
                {
                    socialsData.map(social => {
                        return (
                            <a href={social.url} className={styles.socialLogo} target="_blank" rel="noopener noreferrer">
                                <i className={`fa fa-${social.buttonText.toLowerCase()}`} aria-hidden="true"></i>
                            </a>
                        )
                    })
                }
            </div>
        </section>
    )
}